import { cn } from "lib/utils"
import { useTranslation } from "react-i18next"

interface LogoProps {
  className?: string
  width?: string
  alt?: string
}

export function LogoHorizontal({ className, width = "w-52", alt }: LogoProps) {
  const { t } = useTranslation()
  const logoAlt = alt || t("app.logoAlt")
  return <img src="/images/logo-horizontal.svg" alt={logoAlt} className={cn(width, className)} />
}
